export * from './gedenkportal.component';
export * from './gedenkportal.service';
